import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import useSidebarItems from './items';
import './sidebar.css';

export default function Sidebar({ collapsed = false, onNavigate, themeControl }) {
  const { pathname } = useLocation();
  const items = useSidebarItems();
  const parent = items.find(item => item.children?.some(child => child.link === pathname));
  const parentKey = parent?.key;
  const [openKeys, setOpenKeys] = useState(parent ? [parent.key] : []);
  useEffect(() => { if (parentKey) setOpenKeys(keys => [...new Set([...keys, parentKey])]); }, [parentKey]);
  const selected = items.flatMap(item => item.children || [item]).find(item => item.link === pathname);
  const mapItem = ({ link, label, children, style, ...item }) => ({
    ...item,
    label: link ? <Link to={link} onClick={onNavigate}>{label}</Link> : label,
    children: children?.map(mapItem),
  });
  return <nav className="admin-navigation" aria-label="Admin navigation">
    <Link className="admin-brand" to="/dashboard" aria-label="MasterFut dashboard" onClick={onNavigate}>
      <img className="admin-brand-mark" src={`${process.env.PUBLIC_URL}/favicon.png`} alt="MasterFut" />
      {!collapsed && <span className="admin-brand-name">Masterfut<span>ADMIN CONSOLE</span></span>}
    </Link>
    {!collapsed && <div className="admin-nav-label">WORKSPACE</div>}
    <Menu mode="inline" selectedKeys={selected ? [selected.key] : []} inlineCollapsed={collapsed}
      {...(!collapsed ? { openKeys, onOpenChange: setOpenKeys } : {})} items={items.map(mapItem)} />
    <div className="admin-sidebar-footer">{themeControl}{!collapsed && <span>MasterFut administration</span>}</div>
  </nav>;
}
